import EVENTS from '../../constants/artifacts_events.constants';
import CONFIG_MESSAGES from '../../constants/configuration_messages.constants';

export class AllBuildsController {
    constructor($scope, $q, $timeout, JFrogGridFactory, BuildsDao, JFrogEventBus, JFrogModal,
                JFrogNotifications, JFrogTableViewOptions, User, GoogleAnalytics) {

        this.$scope = $scope;
        // this.uiGridConstants = uiGridConstants;
        this.JFrogTableViewOptions = JFrogTableViewOptions;
        this.user = User.getCurrent();
        this.$timeout = $timeout;
        this.$q = $q;
        this.allBuildsGridOptions = {};
        this.buildsDao = BuildsDao;
        this.artifactoryGridFactory = JFrogGridFactory;
        this.JFrogEventBus = JFrogEventBus;
        this.GoogleAnalytics = GoogleAnalytics;
        this.artifactoryNotifications = JFrogNotifications;
        this.modal = JFrogModal;
        this._createGrid();
        this._getBuildsData();
        this.firstFetch = true;
        this.CONFIG_MESSAGES = CONFIG_MESSAGES.builds;
        this.noBuildsDataMessage = this.CONFIG_MESSAGES.noBuildsDataMessage;
        this.allBuildsGridOptions = {};
    }

    _getBuildsData(dontTrack) {
        this.buildsDao.get().$promise.then((data) => {
            let numOfBuilds = data && data.pagingData ? data.pagingData.length : 0;
            if (!dontTrack) this.GoogleAnalytics.trackEvent('Builds' , 'Number of builds' , numOfBuilds , numOfBuilds);
            this.buildsData = data.pagingData || [];

            this.tableViewOptions.setData(this.buildsData);
        });
    }

    _createGrid() {
        this.tableViewOptions = new this.JFrogTableViewOptions(this.$scope);
        this.tableViewOptions.setColumns(this._getColumns())
                .setRowsPerPage(20)
                .setActions(this._getActions())
                .setBatchActions(this.getBatchActions())
                .setEmptyTableText(this.noBuildsDataMessage)
                .sortBy('time')
                .reverseSortingDir();
    }

    _getColumns() {
        let nameCellTemplate = '<div class="ui-grid-cell-contents"><a href class="jf-link" ui-sref="builds.build_page({buildName:row.entity.buildName,buildNumber:row.entity.buildNumber,startTime:row.entity.time})">{{row.entity.buildName}}</a></div>';
        let numberCellTemplate =    `<div class="ui-grid-cell-contents">
                                       <a href="" class="jf-link" id="last-build-id" ui-sref="builds.build_page({buildName:row.entity.buildName,buildNumber:row.entity.buildNumber,startTime:row.entity.time})" >{{row.entity.buildNumber}}</a>
                                    </div>`;

        let timeCellTemplate = '<div class="ui-grid-cell-contents" id="last-build-time">{{row.entity.time | date: \'d MMMM, yyyy - HH:mm:ss Z\'}}</div>';

        return [
            {
                header: "Build Name",
                field: "buildName",
                cellTemplate: nameCellTemplate,
                filterable: true
            },
            {
                header: "Last Build ID",
                field: "buildNumber",
                cellTemplate: numberCellTemplate,
                width: '10%'
            },
            {
                header: "Last Build Time",
                cellTemplate: timeCellTemplate,
                field: "time",
                width: '15%'
            }
        ]
    }


    getBatchActions() {
        return [
            {
                icon: 'clear',
                name: 'Delete',
                callback: (selected) => this.bulkDelete(selected),
                visibleWhen: () => this.user.isAdmin()
            }
        ]
    }

    bulkDelete(selected) {

        let confirmMessage = `Are you sure you wish to delete ${selected.length}`;
            confirmMessage += selected.length > 1 ? ' build projects?' : ' build project?';

        this.modal.confirm(confirmMessage)
        .then(() => {
            let buildsToDelete = selected.map(build => {
                return {buildName: build.buildName}
            });
            this._deleteBuilds({buildsCoordinates: buildsToDelete});
        });
    }


    deleteBuild(row) {
        this.modal.confirm("Are you sure you wish to delete all the builds '" + row.buildName + "'?")
            .then(() => {
                this._deleteBuilds({buildsCoordinates:[{buildName:row.buildName}]});
            })
    }

    _deleteBuilds(json) {
        this.buildsDao.deleteAll(json).$promise.then(() => {
            this._getBuildsData(true);
            this.tableViewOptions.clearSelection();
        });
    }

    _getActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: row => this.deleteBuild(row),
                visibleWhen: () => this.user.isAdmin()
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./states/builds/all_builds.controller.js